.overlay {
  inset: 0;
  position: fixed;
  z-index: 50;
}

.backdrop {
  // Match the modal backdrop / legacy dialogs (darker dim for focus).
  background: rgba(0, 0, 0, 0.6);
  border: none;
  cursor: default;
  inset: 0;
  position: absolute;
}

.panel {
  // Legacy colour scheme (blue primary + light blue-grey borders), scoped to
  // the panel so it matches legacy + the modals without recolouring pages.
  --color-primary: hsl(208deg 76.9% 47.5%);
  --color-primary-foreground: #fff;
  --color-primary-hover: hsl(208deg 76.9% 41%);
  --color-border: hsl(208deg 30% 90%);
  --color-ring: hsl(208deg 76.9% 47.5%);
  --color-focus: hsl(208deg 76.9% 47.5%);
  // Layout tokens for panel CONTENT. Declared here, on the panel itself, so
  // every drawer body lines up with the header this component draws — and so a
  // consumer cannot drift by hard-coding its own gutter. Scoped to the panel:
  // nothing outside a SlidePanel can see or inherit these.
  --slide-panel-gutter: 24px;
  --drawer-card-radius: 12px;
  animation: slideIn 0.25s ease;
  background: var(--color-background);
  border-left: 1px solid var(--color-border);
  box-shadow: -8px 0 24px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  // Cap to the viewport so the panel never overflows off-screen on mobile.
  // `min()` is needed because the per-instance width is set inline (an inline
  // CSS var would otherwise beat the old `@media` override).
  width: min(var(--slide-panel-width, 600px), 100vw);
  z-index: 10;
}

// Same gutter as the body below it, so the title and the content share one
// vertical grid and the close button sits on the body's right edge.
.header {
  align-items: center;
  border-bottom: 1px solid var(--color-border);
  display: flex;
  justify-content: space-between;
  padding: 20px var(--slide-panel-gutter);
}

.title {
  letter-spacing: 1.2px;
}

.closeBtn {
  align-items: center;
  border-radius: 6px;
  color: var(--color-muted);
  display: flex;
  height: 32px;
  justify-content: center;
  transition: background-color 0.15s;
  width: 32px;

  &:hover {
    background: var(--color-secondary);
  }
}

.closeIcon {
  height: 18px;
  width: 18px;
}

.body {
  flex: 1;
  overflow-y: auto;
}

// Opt-in (`hideScrollbar`): still scrolls, just without the visible track.
.body-hide-scrollbar {
  scrollbar-width: none; // Firefox
  -ms-overflow-style: none; // legacy Edge

  &::-webkit-scrollbar {
    display: none; // Chrome/Safari
  }
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0);
  }
}
